// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"RestrictAddImageModal_modalContent__1k1wK","titleModal":"RestrictAddImageModal_titleModal__3-T4B","learnMore":"RestrictAddImageModal_learnMore__2BezT"};